import ResourceService from "./resource.service";

class RolesService extends ResourceService {
  static get resource() {
    return "role";
  }
}

export default RolesService;
